const fileIconMap = {
  doc: 'wordFile',
  docx: 'wordFile',
  xls: 'excelFile',
  xlsx: 'excelFile',
  bmp: 'showImage',
  gif: 'showImage',
  jpeg: 'showImage',
  jpg: 'showImage',
  png: 'showImage',
  tif: 'showImage',
  tiff: 'showImage',
  ai: 'showImage',
  eps: 'showImage',
  pdf: 'pdfFile',
  ppt: 'powerpointFile',
  pptx: 'powerpointFile',
  txt: 'textFile',
  default: 'file'
};

export function getFileIconClass(extension) {
  return fileIconMap[extension] ? fileIconMap[extension] : fileIconMap.default;
}
